import { SystemStyleObject } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'

const tokens = {
  dark: {
    menuBg: 'bg.input',
    border: 'interactive.tertiary-border',
    optionHover: 'interactive.tertiary-hover-bg',
    text: 'text.primary',
  },
  light: {
    menuBg: 'light.bg.card',
    border: 'light.interactive.tertiary-border',
    optionHover: 'light.interactive.tertiary-hover-bg',
    text: 'light.text.primary',
  },
} as const

// Suggestion menu — mirrors the dark Select menu surface, positioned under the
// input within the (relative) Autocomplete container.
export const menuStyles = (colorScheme: ColorScheme): SystemStyleObject => ({
  position: 'absolute',
  top: 'calc(100% + 4px)',
  left: 0,
  right: 0,
  zIndex: 20,
  bg: tokens[colorScheme].menuBg,
  border: '1px solid',
  borderColor: tokens[colorScheme].border,
  maxH: '220px',
  overflowY: 'auto',
  py: '4px',
})

export const optionStyles = (
  colorScheme: ColorScheme,
  isActive: boolean
): SystemStyleObject => ({
  bg: isActive ? tokens[colorScheme].optionHover : 'transparent',
  color: tokens[colorScheme].text,
  cursor: 'pointer',
  fontFamily: "'Soehne', sans-serif",
  fontSize: '11px',
  px: '10px',
  py: '8px',
})
